(() => {
  'use strict';

  if (window.GmlNumericInputs) return;

  const ignoredTypes = new Set(['hidden', 'checkbox', 'radio', 'range', 'file', 'button', 'submit', 'reset', 'image', 'color', 'date', 'datetime-local', 'time', 'month', 'week']);
  const priceSelector = '[data-price-min],[data-price-max],[data-price-input],[data-finder-price]';
  const digitPattern = /^\^?(?:\\d|\[0-9\])(?:\+|\*|\{\d+(?:,\d*)?\})?\$?$/;

  function setHint(input, name, value) {
    if (input.getAttribute(name) !== value) input.setAttribute(name, value);
  }

  function identify(input) {
    return [input.name, input.id, input.getAttribute('data-numeric-kind') || '']
      .join(' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[^a-z0-9]+/gi, ' ')
      .trim()
      .toLowerCase();
  }

  function apply(input) {
    if (!(input instanceof HTMLInputElement) || input.getAttribute('data-gml-numeric-inputs') === 'off') return;
    const type = input.type.toLowerCase();
    if (ignoredTypes.has(type)) return;

    const autocomplete = (input.getAttribute('autocomplete') || '').trim().toLowerCase();
    if (type === 'email') {
      setHint(input, 'inputmode', 'email');
      return;
    }
    if (type === 'search' || type === 'password' || type === 'url') return;

    const identity = identify(input);
    const tokens = new Set(identity.split(' '));
    const isPhone = type === 'tel' || /(?:^|\s)tel(?:-|\s|$)/.test(autocomplete) || input.hasAttribute('data-phone') ||
      ((tokens.has('phone') || tokens.has('telephone') || tokens.has('mobile')) && !tokens.has('country') && !tokens.has('code'));
    const isPrice = input.matches(priceSelector) || ['price', 'budget', 'amount', 'minprice', 'maxprice'].some(token => tokens.has(token));
    const isYear = input.hasAttribute('data-year') || tokens.has('year');
    const isOneTimeCode = autocomplete.split(/\s+/).includes('one-time-code') || tokens.has('otp') ||
      /(?:^|\s)(?:one time|verification|authentication|auth|login|confirmation) code(?:\s|$)/.test(identity);
    const isCardDigits = /(?:^|\s)cc-(?:number|csc|exp-month|exp-year)(?:\s|$)/.test(autocomplete);

    if (isPhone) {
      setHint(input, 'inputmode', 'tel');
      if (!autocomplete) setHint(input, 'autocomplete', 'tel');
      return;
    }
    if (isPrice) {
      setHint(input, 'inputmode', 'decimal');
      return;
    }
    if (isYear) {
      setHint(input, 'inputmode', 'numeric');
      return;
    }
    if (isOneTimeCode) {
      if (!autocomplete || autocomplete === 'off') setHint(input, 'autocomplete', 'one-time-code');
      const pattern = input.getAttribute('pattern') || '';
      if (!pattern || digitPattern.test(pattern) || type === 'number') setHint(input, 'inputmode', 'numeric');
      return;
    }
    if (type === 'number') {
      const step = input.getAttribute('step');
      setHint(input, 'inputmode', step === 'any' || (step !== null && Number(step) % 1 !== 0) ? 'decimal' : 'numeric');
      return;
    }
    if (isCardDigits || digitPattern.test(input.getAttribute('pattern') || '')) setHint(input, 'inputmode', 'numeric');
  }

  function refresh(root = document) {
    if (root instanceof HTMLInputElement) apply(root);
    if (root.querySelectorAll) root.querySelectorAll('input').forEach(apply);
  }

  const observer = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') apply(record.target);
      else record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) refresh(node);
      });
    });
  });

  function start() {
    refresh();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['type', 'name', 'id', 'autocomplete', 'inputmode', 'step', 'pattern', 'data-phone', 'data-price-min', 'data-price-max', 'data-price-input', 'data-finder-price', 'data-year', 'data-numeric-kind', 'data-gml-numeric-inputs']
    });
    document.addEventListener('focusin', event => apply(event.target), true);
  }

  window.GmlNumericInputs = Object.freeze({ refresh });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
